import React, { Component } from 'react';

import { Icon } from 'components';

class FormIcon extends Component {
  render() {
    const { name, children } = this.props;

    return (
      <div className="form-icon">
        {children}

        <Icon name={name} />
      </div>
    );
  }
}

export default FormIcon;
